import API from 'services/API';

export default function addInspection(data) {
  let requestData = new FormData();
  requestData.append('taxId', data.id);

  return API.request({
    method: 'POST',
    url: '/addTaxAuthority',
    data: requestData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
